
const setProperty = (prop, value) => {
  const dataLayer = window.dataLayer[0];
  dataLayer[prop] = value;
}

module.exports = {
  setProperty
}